import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: "root",
})
export class NewsletterService {
    private _api_server = environment.API_ADDRESS;
    constructor(private _http: HttpClient) {}

    header = new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Miwicm9sZSI6IkFkbWlucyIsImlzU3VwZXJBZG1pbiI6ZmFsc2UsImlhdCI6MTY3NzA4NDQwOH0.vS-rDTKS1j3Rvg44ZBD-PkHqFFrm6HReyN10EyPkvx0
        `,
    });

    getNewsletterConfig(crowdsaleAddress) {
        return this._http.get(
            this._api_server +
                "/newsletter/config/byAddr?addressOnChain=" +
                crowdsaleAddress,
            { headers: this.header }
        );
    }

    addSubscriberToNewsletter(crowdsaleAddress, email) {
        return this._http.post(
            this._api_server + "/newsletter",
            { crowdsaleAddress, email },
            { headers: this.header }
        );
    }
}
